import { FC } from "react";
import { Form } from "react-bootstrap";
import Select, { StylesConfig } from "react-select";
import { OptionModel } from "../../shared/models/option.model";
import SkeletonComponent from "src/shared/custom-spinner/skeleton.component";

interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps {
  options: OptionModel[];
  selectedValue?: string;
  placeHolder?: string;
  isShowLabel?: boolean;
  onChange: (selectedValue: any) => void;
  customeStyle?: boolean;
  isLoading?: boolean;
}

const SelectComponent: FC<SelectProps> = ({
  options,
  selectedValue = null,
  placeHolder = "select",
  isShowLabel = true,
  onChange,
  customeStyle = false,
  isLoading = false,
}) => {
  const formattedOptions: SelectOption[] =
    options?.map((option) => ({
      value: option.value,
      label: option.title,
    })) ?? [];

  const selectOptions = isShowLabel
    ? [{ value: "", label: placeHolder }, ...formattedOptions]
    : formattedOptions;

  const selectedOption =
    selectOptions.find((option) => option.value === (selectedValue ?? "")) ??
    null;

  const styles: StylesConfig<SelectOption, false> = {
    control: (provided) => ({
      ...provided,
      height: customeStyle ? "35px" : "2.75rem",
      minHeight: customeStyle ? "35px" : "2.75rem",
      minWidth: "140px",
      cursor: "pointer",
      ...(customeStyle
        ? {
          paddingLeft: "1rem",
        }
        : {}),
    }),
  };

  return (
    <SkeletonComponent
      wrapperHeight="50px"
      skeletonHeight="40px"
      isLoading={isLoading}
    >
      <Form.Group>
        <Select
          options={selectOptions}
          value={selectedOption}
          onChange={(option) => onChange(option?.value ?? "")}
          placeholder={isShowLabel ? placeHolder : ""}
          isSearchable
          classNamePrefix="selectContainer"
          styles={styles}
        />
      </Form.Group>
    </SkeletonComponent>
  );
};

export default SelectComponent;
